var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.groups
    ? _c(
        "div",
        {
          staticClass: "scheduler border-none bg-white",
          class: _vm.schedulerClasses,
        },
        [
          _vm._t("group"),
          _vm._t("item"),
          _c("timeline", {
            ref: "timeline",
            attrs: {
              items: _vm.items,
              groups: _vm.groups,
              options: _vm.options,
            },
            on: {
              rangechanged: _vm.rangeChanged,
              click: _vm.handleClick,
              select: _vm.handleSelect,
            },
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }